import React from "react";
import { getAvatarColor, getInitials } from "../Meetings/Meetings.utils";
import { formatTime, resolveMentions } from "./Conversation.utils";
import { useConversationContext } from "./ConversationContext";

function ParticipantListItem({ participant, isSelected, onSelect }) {
  const { authorMap } = useConversationContext();
  const { displayName, messages = [] } = participant;
  const lastMessage = messages[0];

  return (
    <button
      type="button"
      onClick={onSelect}
      className={`btn w-100 text-start border-0 rounded-3 px-2 py-2 mb-1 d-flex gap-2 align-items-start conv-list-item ${
        isSelected ? "bg-primary-subtle" : "bg-theme"
      }`}
    >
      <div
        className="rounded-circle d-flex align-items-center justify-content-center fw-bold flex-shrink-0 text-white conv-avatar-sm"
        style={{ backgroundColor: getAvatarColor(displayName) }}
      >
        {getInitials(displayName)}
      </div>

      <div className="flex-grow-1 min-w-0 conv-list-item">
        <div className="d-flex align-items-baseline justify-content-between gap-2">
          <span
            className="fw-semibold text-truncate d-block flex-grow-1 min-w-0 conv-author-name"
            style={{ color: getAvatarColor(displayName) }}
          >
            {displayName}
          </span>
          {lastMessage?.sentAt && (
            <small className="text-body-secondary fw-normal flex-shrink-0 conv-time-xs">
              {formatTime(lastMessage.sentAt)}
            </small>
          )}
        </div>

        <div className="text-body-secondary conv-preview-text">
          {lastMessage?.text?.trim()
            ? resolveMentions(lastMessage.text, authorMap)
            : "(no content)"}
        </div>

        <div className="d-flex justify-content-end align-items-center mt-1">
          <span className="badge bg-secondary-subtle text-secondary-emphasis rounded-pill fw-normal">
            {messages.length} {messages.length === 1 ? "message" : "messages"}
          </span>
        </div>
      </div>
    </button>
  );
}

export default ParticipantListItem;